import type { Dictionnaire } from '../type';

export const appels: Dictionnaire['appels'] = {
  erreurs: {
    camera: 'لا يستطيع Sirocco الوصول إلى الكاميرا.',
    micro: 'لا يستطيع Sirocco الوصول إلى الميكروفون.',
    connexion: 'تعذّر إنشاء الاتصال. جرّب من شبكة أخرى.',
    compteOfficiel: 'حساب التطبيق لا يستقبل المكالمات. راسله.',
    pasAmi: 'يمكنك الاتصال بأصدقائك فقط. أضف هذا العضو أولًا.',
    pasAbouti: 'تعذّر إتمام المكالمة.',
    nExistePlus: 'هذه المكالمة لم تعد موجودة.',
  },
  natif: {
    pasAbouti: 'تعذّر إتمام المكالمة.',
  },
  ecran: {
    quelquun: 'شخص ما',
    personneNaRepondu: 'لم يردّ أحد.',
    pasParti: 'تعذّر إجراء المكالمة.',
    pasAbouti: 'تعذّر إتمام المكالمة.',
    echanger: 'تبديل الصورتين',
    reduire: 'تصغير المكالمة',
    appel: 'مكالمة',
    connexion: 'جارٍ الاتصال…',
    appelVideo: 'مكالمة فيديو…',
    appelEnCours: 'جارٍ الاتصال…',
    refuser: 'رفض',
    repondreVideo: 'الردّ بالفيديو',
    repondre: 'ردّ',
    accepter: 'قبول',
    reactiverMicro: 'تشغيل الميكروفون',
    couperMicro: 'كتم الميكروفون',
    montrerCamera: 'إظهار الكاميرا',
    cameraPasOuverte: 'تعذّر فتح الكاميرا.',
    rallumerCamera: 'إعادة تشغيل الكاميرا',
    couperCamera: 'إيقاف الكاميرا',
    ecouteur: 'العودة إلى السمّاعة',
    hautParleur: 'التحويل إلى مكبّر الصوت',
    raccrocher: 'إنهاء المكالمة',
    entrant: { video: 'مكالمة فيديو واردة…', audio: 'مكالمة واردة…' },
    son: (detail: string) => `الصوت: ${detail}`,
    natifMuet: 'الطبقة الأصلية لا تستجيب',
  },
};
